<template>
  <div class="basic">
    <v-overlay
      opacity="0.3"
      :value="overlay"
      z-index="10"
    >
      로그인중입니다.
    </v-overlay>
    <v-row dense>
      <v-col cols="12" align="center" class="caption">
        SNS 로그인/회원가입
      </v-col>
    </v-row>
    <v-divider class="mt-3 mb-3" />
    <v-row dense>
      <v-col cols="4" align="center">
        <v-btn
          fab
          elevation=0
          @click="googlelogin">
          <v-img width="30" src="https://s3.ap-northeast-2.amazonaws.com/images.wintersleeping/googleicon.png" />
        </v-btn>
      </v-col>
      <v-col cols="4" align="center" >
        <v-btn
          fab
          elevation=0
          @click="kakaologin">
          <v-img width="30" src="https://s3.ap-northeast-2.amazonaws.com/images.wintersleeping/kakaoicon.png" />
        </v-btn>
      </v-col>
      <v-col cols="4" align="center" >
        <div id="naverIdLogin" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable no-console, no-unused-var, no-undef */
/* eslint-disable no-unused-vars */
import firebase from 'firebase/app';
import 'firebase/auth';
import axios from 'axios';

// import KakaoLogin from 'vue-kakao-login'

import api_conf from '../../config/config.json';

Kakao.init(api_conf.kakao.id);

import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
  data: () => {
    return {
      overlay: false,
      snackbar: false,
      errmsg: "",
      valid: false,
      email: "",
      emailRules: [
        v => !!v || '이메일을 입력하세요.',
        v => /.+@.+/.test(v) || '이메일이 유효하지 않습니다.',
      ],
      password: "",
      passRules: [
        v => v.length >= 8 || '최소 8글자를 입력하세요.',
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
      kakao: "kakao",
    })
  },
  mounted: async function() {

    var naverLogin = new naver.LoginWithNaverId(
      {
        clientId: api_conf.naver.client_id,
        callbackUrl: api_conf.naver.redirect_url,
        isPopup: false, /* 팝업을 통한 연동처리 여부 */
        loginButton: {color: "green", type: 1, height: 40},
        // userLoginButtons: "https://s3.ap-northeast-2.amazonaws.com/images.wintersleeping/navericon.png",
      }
    );


    /* 설정정보를 초기화하고 연동을 준비 */
    naverLogin.init();

    // 네이버 커스텀 로그인 버튼

    let n_btn = document.getElementById('naverIdLogin').getElementsByTagName('img')[0];
    n_btn.src = "https://s3.ap-northeast-2.amazonaws.com/images.wintersleeping/navericon.png";
    n_btn.width = "56";
    n_btn.height = "56";

  },
  methods: {
    googlelogin: async function(ev) {
      this.overlay=true;
      try {
        const provider = new firebase.auth.GoogleAuthProvider();

        const res = await firebase.auth().signInWithPopup(provider);

        await this.$store.dispatch("fetchUser", res.user);

        const id_token = await firebase.auth().currentUser.getIdToken(true);
        await this.$store.dispatch("postIDToken", id_token);
        const is_exist = await axios.get(
          api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/user/is', {
          params: { email: res.user.email },
          headers: {id_token: id_token},
        });

        this.overlay=false;

        if(is_exist.data==0) {
          this.$router.push({ path: "/agreement" });
        } else {
          this.$router.push({ path:"/main" });
        }
      } catch(e) {
        this.overlay=false;
      }
    },
    async facebooklogin(ev) {
      const provider = new firebase.auth.FacebookAuthProvider();

      const res = await firebase.auth().signInWithPopup(provider);

      const id_token = await firebase.auth().currentUser.getIdToken(true);
      await this.$store.dispatch("postIDToken", id_token);
      const is_exist = await axios.get(
        api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/user/is', {
        params: { email: res.user.email },
        headers: {id_token: id_token},
      });

      if(is_exist.data==0) {
        await axios.post(api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/user', {
          name: res.user.displayName,
          uid: res.user.uid,
          email: res.user.email,
        }, {
          headers: {'id_token': id_token},
        });
      }

      this.$router.push({ path:"/main" });
    },

    //////////////////////////////////////////////////////////////////////////////////
    kakaologin: async function() {
      this.overlay=true;
      Kakao.Auth.login({
        success: (authObj) => this.kakao_success(authObj),
        fail: (err) => this.kakao_failure(err)
      });
    },
    kakao_success: async function(data) {
      let customtoken = await axios.post(api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/kakao/auth', {
        token: data.access_token,
      });

      const res = await firebase.auth().signInWithCustomToken(customtoken.data.token);

      await this.$store.dispatch("fetchUser", res.user);

      const id_token = await firebase.auth().currentUser.getIdToken(true);
      await this.$store.dispatch("postIDToken", id_token);
      const is_exist = await axios.get(
        api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/user/is', {
        params: { email: customtoken.data.email },
        headers: {id_token: id_token},
      });

      this.overlay=false;

      if(is_exist.data==0) {
        this.$router.push({ path: "/agreement" });
      } else {
        this.$router.push({ path:"/main" });
      }
    },
    kakao_failure: async function(data) {
      this.overlay=false;
      this.snackbar = false;
      this.snackbar = true;
      this.errmsg = "카카오톡 로그인에 문제가 있습니다.";
    },
    reset() {
      this.email = "";
      this.password = "";
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul li {
  margin: 10px;
  list-style:none;
}

</style>
